<mat-progress-spinner
  class="spinner"
  mode="indeterminate"
  *ngIf="!currentLessonData">
</mat-progress-spinner>

<section *ngIf="currentLessonData" class="profile-results-lesson">
  <div class="profile-results-lesson__content">
    <div class="row">
      <div class="profile-results-lesson__content__exercises">
        <p>
          <span style="color: #ADB5C0">Решено верно: </span>
          <span class="profile-results-lesson__content__exercises__count-correct">
          {{ currentLessonData.analytics ? currentLessonData.analytics?.exercises.count_correct_exercises : '0' }}
        </span>
          из {{ currentLessonData.analytics ? currentLessonData.analytics?.exercises.count_exercises : 0 }} заданий.
        </p>
        <a (click)="openExercises()"
           class="profile-results-lesson__content__exercises__more">...подробнее</a>
      </div>
      <div class="profile-results-lesson__content__money">
        <p>
          <span style="color: #ADB5C0">Заработано: </span>
          <span class="profile-results-lesson__content__money__count">
            {{ currentLessonData.analytics ? currentLessonData.analytics?.count_earned : '0' }}
          </span>
          <span style="color: #6E95C8">{{ currencyStr }}</span>.
        </p>
      </div>
    </div>
    <div class="profile-results-lesson__content__stars row">
      <div class="profile-results-lesson__content__stars__jar">
        <span class="profile-results-lesson__content__stars__jar__count_star">{{ currentLessonData.count_user_stars }}</span>
        <span><img src="/assets/images/magic_jar.svg" alt="***"></span>
      </div>
      <div *ngIf="currentLessonData.stars?.length" class="profile-results-lesson__content__stars__awards">
        <span *ngIf="userPhoto" class="student_awatar">
          <img src="{{ userPhoto }}" alt="">
        </span>
        <ul>
          <li class="profile-results-lesson__content__stars__awards__item" *ngFor="let star of currentLessonData.stars">
            <span class="profile-results-lesson__content__stars__awards__cloud">
              <img src="{{ star.type_achievement.cloud }}" alt="@@@">
            </span>
            <span (click)="showStarModal(star)" class="profile-results-lesson__content__stars__awards_star">
              <img src="{{ star.type_achievement.star }}" alt="">
            </span>
            <span class="profile-results-lesson__content__stars__awards__description">
              {{ star.type_achievement.title }}
            </span>
          </li>
        </ul>
      </div>
    </div>
    <div class="profile-results-lesson__content__photo row"></div>
  </div>
</section>

<ng-container *ngIf="toggleStarModal">
  <app-profile-results-star-description
    [starImg]="starData.type_achievement.star"
    [title]="starData.type_achievement.title"
    [explanation]="starData.explanation"
    [exercises]="starData.exercises_results"
    (showModal)="starModal()">
  </app-profile-results-star-description>
</ng-container>
